const getDefaultState = () => {
    return {
        products: [],
        currentProduct: null,
        currentMedias: [],
        editMode: false
    }
}

const aura = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setDefaultProduct(state) {
            state.currentProduct = {
                name: null,
                thematicStays: [],
                commune: null,
                dayNumber: null,
                nightNumber: null,
                bookingEmail: null,
                bookingPhone: null,
                descriptionFr: null,
                descriptionFrLong: null,
                descriptionEn: null,
                descriptionEnLong: null,
                childPrice: null,
                adultPrice: null,
                customerTypes: [],
                coverTerritories: [],
                languages: [],
                photos: [],
                documents: [],
                links: [
                    {value: null}
                ]
            }
        },
        setEditMode(state, data) {
            state.editMode = data
        },
        setCurrentProduct(state, data) {
            state.currentProduct = data
        },
        updatePhotoName(state, [data, index]) {
            state.currentProduct.photos[index].name = data
        },
        updatePhotoCopyright(state, [data, index]) {
            state.currentProduct.photos[index].copyright = data
        },
        pushProduct(state, data) {
            state.products.push(data)
        },
        setProducts(state, data) {
            state.products = data
        }
    }
}

export default aura